import React, {useState} from "react";
import {FieldEditableValueNotEmptyProps} from "../../../../proto/components/editable/value-not-empty";
import {FieldViewSize} from "../../../../const";

export default function FieldEstimate_InlineValueEmpty(props:FieldEditableValueNotEmptyProps) {


    const size = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const toggleIsHovered = () => {
        setIsHovered(!isHovered)
    }

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const className = Classes("ui5-field-editable w-100-percent", "size-"+size, {
        'is-hovered'        : isHovered || props.children
    })

    const valueClass = Classes({
        'ui5-txt-default'                   : size === FieldViewSize.DEFAULT,
        'ui5-txt-less-important-small'      : size === FieldViewSize.SMALL,
    })

    if (isHovered || props.children) {
        return (
            <React.Fragment>
                <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

                    <div className={valueClass}>{props.field.placeholder}</div>
                    <div className="buttons">
                        <div className="btn-arrow"/>
                    </div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    // not hovered
    return (
        <React.Fragment>
            <div className={Classes(className, valueClass)} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {/*{props.field.placeholder}*/}
                <div className="min-w-100"></div>
            </div>
        </React.Fragment>
    )


}
